export default __webpack_public_path__ + "ba79756fb5c8dafa5b9066e19dd71694.png";